import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const podium = defineConnector({
  identifier: "podium",
  name: "Podium",
  tagLine: "Customer messaging platform",
  logo,
  protocol: "http",
  tags: ["communication", "productivity"],
  defaultUrlPattern: () => "https://api\\.podium\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Podium instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Podium instance.",
        },
        {
          kind: "input",
          label: "API Version",
          placeholder: "your-apiVersion",
          required: true,
          target: { kind: "configuration", field: "apiVersion" },
          helperText: "The API version of your Podium account",
        },
      ],
    },
    {
      title: "Create a Podium app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Podium Developer Portal](https://docs.podium.com/) and create a new application to get your OAuth credentials.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/podium/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Podium account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Podium account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://api.podium.com/oauth/authorize",
    tokenEndpoint: () => "https://api.podium.com/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.podium.com/v4/locations",
  },
});
